import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Typography
} from '@mui/material';
import _ from 'lodash';
import * as ds from './dataService';
import { StyledTextField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import { SaveClientReport_Input } from 'generated/graphql';


export type ApproveClientReportFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: ApproveClientReportFormProps) => {
  const [
    fnSaveClientReportForm,
    { loading }
  ] = ds.useSaveClientReport();
  const form = ds.useFormState(props.id, props.projectId);

  const handleSubmit = async (input: SaveClientReport_Input) => {

    await fnSaveClientReportForm({
      id: input.id,
      approved: true
    });

    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'sent',
        value: true
      }
    });

  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit({
          id: form.formState.id,
          approved: form.formState.approved,
          projectId: form.formState.projectId,
          description: form.formState.description
        });
        _.delay(() => {
          props.handleClose();
        }, 2000);
      }}
      cancelButtonText='Cancel'
      successButtonText='Send to Client'
      isLoading={loading}
    >
      {form.formState.sent
        ? (
          <>
            <Typography
              variant='modalTitle'
            >
              SENT!
            </Typography>
          </>
        )
        : (
          <>

            <StyledTextField.FC
              {...form.genFieldProps('description')}
              minRows={4}
            />
            <FormControl>
              <FormControlLabel
                control={(
                  <Checkbox
                    onClick={() => form.dispatch({
                      type: 'UPDATE',
                      payload: {
                        property: 'approved',
                        value: !form.formState.approved
                      }
                    })}
                    disabled={form.formState.disableApproval}
                    checked={form.formState.approved}
                  />
                )}
                label='Approved'
              />
            </FormControl>

          </>
        )}
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
